<script>
import Vue from 'vue'
import {mapActions} from 'vuex'
import {
  COUNTRY_ARRIVO,
  IATA_ARRIVO,
  REPARTO_NAME,
  WS_URL
} from '../../utils/config'
import {SERVER_DATE_FORMAT} from '../../utils/formatter'
import {ERROR_GENERIC} from '../../utils/messages'

export default {
  name: 'SearchExperienceAction',
  methods: {
    ...mapActions(['loadingStartWithSlider', 'loadingEndWithSlider']),
    searchExperience (payload) {
      const {searchData, experience} = payload
      const voloGiornoSuccessivo = this.$store.getters.getVettori.voloGiornoSuccessivo
      const codiceHotelAlternativo = this.$store.getters.getVettori.codiceHotelAlternativo
      const vettori = this.$store.getters.getVettori.list.map(item => {
        return item.id
      })
      const hotels = this.$store.getters.getHotels.list.map(item => {
        return {countryCode: COUNTRY_ARRIVO, provider: item.fornitore.name, code: item.codice}
      })
      const servizi = this.makeServizi(experience)
      const tours = this.makeTour(searchData, experience)
      const hotelPeriods = this.makeHotelPeriods(searchData, experience)

      return new Promise((resolve, reject) => {
        const camere = searchData.camere.map(function (item, index) {
          return {id: index + 1, adults: item.adults, childs: item.childs}
        })
        const payload = {
          hotelPeriods: hotelPeriods,
          travelGroup: camere,
          flightRequest: {
            iataPartenza: searchData.aereoporto.value,
            iataArrivo: IATA_ARRIVO,
            startDate: searchData.andata,
            endDate: searchData.ritorno,
            vettori: vettori,
            voloGiornoSuccessivo,
            codiceHotelAlternativo
          },
          hotels: hotels,
          tours: tours,
          servizi: servizi
        }

        this.loadingStartWithSlider()
        Vue.axios.post(`${WS_URL}experience/record`, payload, {withCredentials: true}).then(response => {
          const data = response.data
          if (!data.done && data.messages) {
            const error = {error: true, messages: data.messages}
            this.$toastr.error(ERROR_GENERIC)
            reject(error)
          } else {
            resolve(response)
          }
        }).catch(error => {
          this.$toastr.error(ERROR_GENERIC)
          reject(error)
        }).finally(() => {
          this.loadingEndWithSlider()
        })
      })
    },
    makeHotelPeriods (searchData, experience) {
      // creo la tabella delle date, ad ogni variante del flag inserisco la data di domani
      const list = experience.days
      let newFlag = false
      let dates = []
      const start = this.getStart(searchData)
      dates.push(start)
      let nextFlag = true
      list.forEach((item, index) => {
        if (item.isHotelRichiesto && item.isTourAbilitato) {
          newFlag = true
        } else {
          newFlag = false
        }
        const current = this.$moment(start, SERVER_DATE_FORMAT).add('days', index).format(SERVER_DATE_FORMAT)
        if (newFlag === nextFlag) {
          dates.push(current)
          nextFlag = !nextFlag
        }
      })
      dates.push(searchData.ritorno)
      // creo la tabella dei periods
      let periods = []
      for (let index = 0; index < dates.length; index += 2) {
        periods.push([dates[index], dates[index + 1]])
      }
      return periods
    },
    makeServizi (experience) {
      // estrae tutti servizi disponibili in configurazione
      let serviceList = this.$store.getters.getServizi.list.map(item => {
        return {locationId: {countryCode: COUNTRY_ARRIVO, provider: item.fornitore.name, code: item.codice}, days: item.days}
      })
      // estrae i servizi presenti nell'experience
      let list = []
      experience.days.forEach(day => {
        if (day.list) {
          let results = day.list.map((item) => {
            const days = experience.daysSelected
            return {locationId: {countryCode: COUNTRY_ARRIVO, provider: item.fornitore.name, code: item.codiceServizio.trim()}, days}
          })
          // aggiunge il codice tour solo se non è già presente
          /*
          if (day.isHotelRichiesto && day.isTourAbilitato && !results.find(item2 => item2.codice === day.codiceTour)) {
            results.push({locationId: {countryCode: COUNTRY_ARRIVO, provider: REPARTO_NAME, code: day.codiceTour.trim()}, days: experience.daysSelected})
          }
          */
          list = list.concat(results)
        }
      })
      // elimina i record doppi
      return serviceList.concat(list.filter(item => {
        return !serviceList.some(item2 => item2.locationId.code === item.locationId.code)
      }))
    },
    makeTour (searchData, experience) {
      let list = []
      const start = this.getStart(searchData)
      experience.days.forEach((day, index) => {
        const current = this.$moment(start, SERVER_DATE_FORMAT).add('days', index).format(SERVER_DATE_FORMAT)
        if (/* item.isHotelRichiesto && */ day.isTourAbilitato && day.codiceTour && !list.some(item => item.productId === day.codiceTour)) {
          list.push({productId: day.codiceTour, startDate: current, reparto: REPARTO_NAME})
        }
      })
      return list
    },
    getStart (searchData) {
      if (this.$store.getters.isGiornoSuccessivoObbligatorio) {
        return this.$moment(searchData.andata, SERVER_DATE_FORMAT).add(1, 'days').format(SERVER_DATE_FORMAT)
      }
      return searchData.andata
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/actions/SearchExperienceAction.vue